export default {
	en: {
		main_header: 'Find the game you are looking for:',

	},
	es: {
		main_header: 'Encontrá el juego que buscás:',
	}
}